import { Image, Text } from 'platform-components';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';

import CreateClassButton from '../../create-class-button/create-class-button';

import './journal__empty.scss';

export const Empty = ({ intl }) => {
    return (
        <div className="journal__empty">
            <Image
                alt={intl.formatMessage({ id: 'journal.withoutClass.addClass.description' })}
                className="journal__empty-img"
                src={intl.formatMessage({ id: 'journal.withoutClass.img' })}
            />
            <div className="journal__empty-title">
                <Text id="journal.withoutClass.addClass" size={Text.SIZE.XXL} weight={Text.WEIGHT.M} />
            </div>
            <div className="journal__empty-description">
                <Text id="journal.withoutClass.addClass.description" size={Text.SIZE.XL} />
            </div>
            <CreateClassButton />
        </div>
    );
};

Empty.propTypes = {
    intl: PropTypes.object.isRequired,
};

export default injectIntl(Empty);
